import React, { useEffect } from "react";

export const KendoSingleFileUpload = ({ name, onChange, clearWhen }) => {
  useEffect(() => {
    let fileUplaod = $(`#${name}`).data("kendoUpload");
    if (fileUplaod) {
      fileUplaod.destroy();
    }
    $(`#${name}`).kendoUpload({
      multiple: false,
    });
  }, []);

  useEffect(() => {
    let uploder = $(`#${name}`).data("kendoUpload");
    if (uploder) {
      uploder.removeAllFiles();
    }
  }, [clearWhen]);

  return (
    <input
      name={name}
      id={`${name}`}
      type="file"
      aria-label="files"
      onChange={onChange}
    />
  );
};
